import { updatePdlPage, updatePdlUser, triggerOmnitureEvent } from '@bingads-webui-campaign/global-app-init';

export const SP_STANDALONE_PAGE = {
  SIGNUP_PAGE: {
    navLevel3: 'standalone_signup',
    navLevel3Title: 'Welcome to Smart Pages!',
  },
  EDITOR_PAGE: {
    navLevel3: 'standalone_editor',
    navLevel3Title: 'Smart Page Editor',
  },
  DASHBOARD_PAGE: {
    navLevel3: 'standalone_dashboard',
    navLevel3Title: 'Smart Page Dashboard',
  },
};

export const omnitureAccountCreated = (serverContext) => {
  const {
    CurrentAccount,
  } = serverContext;
  updatePdlUser(serverContext);
  triggerOmnitureEvent({
    ...SP_STANDALONE_PAGE.SIGNUP_PAGE,
    user: {
      aid: CurrentAccount.Id,
      cid: CurrentAccount.AdvertiserCustomerID,
      accountMode: CurrentAccount.AccountMode,
    },
  });
};

export const omnitureEditorPageLoad = () => {
  updatePdlPage({
    ...SP_STANDALONE_PAGE.EDITOR_PAGE,
  });
};

export const omnitureDashboardPageLoad = () => {
  updatePdlPage({
    ...SP_STANDALONE_PAGE.DASHBOARD_PAGE,
  });
};
